import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { LocaleProvider } from 'antd';
import { ThemeProvider } from 'styled-components';
import moment from 'moment-timezone';
import enUS from 'antd/lib/locale-provider/en_US';
import wildcard from 'wildcard';
import createStore from 'utils/createStore';
import createHistory from 'history/createBrowserHistory';

import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import colors from './theme/colors';
import 'whatwg-fetch';
import 'antd/dist/antd.css';
import 'font-awesome/css/font-awesome.min.css';
import 'draft-js/dist/Draft.css';

moment.tz.setDefault('Asia/Bangkok');

window.wildcard = wildcard;
const history = createHistory();
const store = createStore(history);

const rootElement = document.getElementById('root');

ReactDOM.render((
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <LocaleProvider locale={enUS}>
        <ThemeProvider theme={colors}>
          <App />
        </ThemeProvider>
      </LocaleProvider>
    </ConnectedRouter>
  </Provider>
), rootElement);
// registerServiceWorker();

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    ReactDOM.render((
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <LocaleProvider locale={enUS}>
            <ThemeProvider theme={colors}>
              <NextApp />
            </ThemeProvider>
          </LocaleProvider>
        </ConnectedRouter>
      </Provider>
    ), rootElement);
  });
}



// WEBPACK FOOTER //
// ./src/index.js